import { render, staticRenderFns } from "./TargetQuestion.vue?vue&type=template&id=33e4a7d3&scoped=true"
import script from "./TargetQuestion.vue?vue&type=script&lang=js"
export * from "./TargetQuestion.vue?vue&type=script&lang=js"
import style0 from "./TargetQuestion.vue?vue&type=style&index=0&id=33e4a7d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e4a7d3",
  null
  
)

export default component.exports